var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 59,
    viewBox: "0 0 73 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 8H7V58H57V31.75",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26.2414L25.1628 47L69 4",
    stroke: "url(#paint0_linearlololol)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linearlololol",
    x1: 7.5,
    y1: 34.5,
    x2: 80,
    y2: -35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43FFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FFBB",
    stopOpacity: 0
  })))));
}

export default SvgCheckbox;